import React from 'react';

const PromoCodeInput = ({ promoCode, setPromoCode, isValid, isChecking }) => (
    <div style={{ position: 'relative', width: '300px' }} className='mt1rem'>
        <input
            type='text'
            placeholder='Enter a diligentsia discount code'
            className={`px1rem py0-75rem bo42 bss bw1px br10px fs14px w100 ${!isValid && promoCode ? 'border-red' : ''}`}
            value={promoCode}
            onKeyDown={(e) => e.key === ' ' && e.preventDefault()}
            onChange={(e) => setPromoCode(e.target.value.replace(/\s/g, ''))}
        />
        {promoCode.trim() !== "" && (
            <button
                onClick={() => setPromoCode("")}
                className="clear-input-btn pa t10px r10px bg44"
                aria-label="Clear input"
            >
                ×
            </button>
        )}
        {isChecking && <p className='c15 op70 fs12px mt1rem'>Checking code...</p>}
        {!isValid && promoCode && !isChecking && <p className='c15 op70 fs12px mt1rem text-red'>Invalid code</p>}
    </div>
);

export default PromoCodeInput; 